/* eslint-disable max-lines-per-function */

/* eslint-disable complexity */
import _ from 'lodash';
import { InputFieldConfig } from 'src/@vymo/ui/molecules/form/types';
import { Keys, locale } from 'src/i18n';
import { ACTIVITY } from 'src/models/lmsConfig/constants';
import { DISPOSITION_GROUP } from '../../constant';

export const getActivityDetailsFieldsGrouping = ({
  activityDetailsInputs,
}: {
  activityDetailsInputs?: InputFieldConfig[];
}) => [
  {
    code: 'engagementDetails',
    name: locale(Keys.ENGAGEMENT_DETAILS),
    fields: (activityDetailsInputs || [])
      .filter((field) => field.code !== DISPOSITION_GROUP)
      .map((field) => field.code),
  },
  {
    code: 'engagementOutcome',
    name: locale(Keys.ENGAGEMENT_OUTCOME),
    fields: (activityDetailsInputs || [])
      .filter((field) => field.code === DISPOSITION_GROUP)
      .map((field) => field.code),
  },
];

export const getActivityEntityInputsAndGroups = ({
  filteredInputs = [],
  inputsMap,
  revyreConfig,
}: {
  filteredInputs?: InputFieldConfig[];
  inputsMap?;
  revyreConfig?;
}) => {
  const groupedFields = getActivityDetailsFieldsGrouping({
    activityDetailsInputs: filteredInputs,
  });

  const entityOutcomeGroup = inputsMap?.outcomeGroup;
  const entityWorkflowType = inputsMap?.workflowType;
  const entityWorkflowConfig = revyreConfig?.[entityWorkflowType];
  const events = entityWorkflowConfig?.events;

  const {
    detailInputs = [],
    inputs: eventFallbackInputs = [],
    groups: eventGroups = [],
  } = events?.find((event) => event.allowedAction === entityOutcomeGroup)
    ?.config ?? {};

  return {
    filteredInputs: _.uniqBy(
      filteredInputs.concat(detailInputs || eventFallbackInputs),
      'code',
    ),
    groups: groupedFields.concat(eventGroups),
  };
};

export const getEntityInputsAndGroups = (props, details, revyreConfig) => {
  if (!details) return { inputs: [], groups: [] };

  if (props.revyre) {
    const { workflowType, domainType } = props;
    const { inputsMap } = details;
    const domainConfig = revyreConfig?.[domainType];
    const workflowConfig = revyreConfig?.[workflowType];
    const formValues = {};

    const { createConfig } = domainConfig ?? {};
    let { detailsConfig } = domainConfig ?? workflowConfig ?? {};

    const { activityType, workflowType: parentAssociatedWorkflow } =
      inputsMap || {};

    if (parentAssociatedWorkflow && activityType) {
      detailsConfig = {
        inputs: revyreConfig?.[parentAssociatedWorkflow]?.activityConfig?.find(
          (config) => config.type === activityType,
        )?.detail_inputs,
        groups: [],
      };
    }
    const { inputs = [] } = detailsConfig ?? createConfig ?? { inputs: [] };
    let { groups = [] } = detailsConfig ?? createConfig ?? { groups: [] };

    let filteredInputs = _.filter(inputs, (input) => {
      formValues[input.code] = { value: inputsMap?.[input?.code] };
      return inputsMap?.[input?.code];
    });

    if (domainType === ACTIVITY) {
      ({ filteredInputs, groups } = getActivityEntityInputsAndGroups({
        filteredInputs,
        inputsMap,
        revyreConfig,
      }));
    }

    const { profiles = [] } = details ?? {};

    const profileInputs = profiles.map((profile, index) => {
      const code = `profile_${index + 1}`;
      const hint = profile?.description || `Profile ${index + 1}`;
      const value = profile?.name || '';
      formValues[code] = { value };
      return {
        code,
        default_value: null,
        hidden: false,
        hint,
        oifOptions: null,
        placeholder: '',
        read_only: false,
        required: true,
        source: undefined,
        type: 'text',
        value,
      };
    });

    if (profileInputs?.length) {
      filteredInputs = [...filteredInputs, ...profileInputs];
      groups = [
        {
          code: 'profileGroup',
          name: 'Profiles',
          fields: profileInputs.map((inp) => inp.code),
        },
        ...(groups || []),
      ];
    }

    return { inputs: filteredInputs, groups, formValues };
  }

  return { inputs: [], groups: [], formValues: {} };
};
